var _g, _g2, _line, _line2, _line3, _line4, _line5, _g3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIdeas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 43,
    viewBox: "0 0 31 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_202_1424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5222 6.42406C15.0755 6.01062 15.8348 6.01061 16.3881 6.42406L23.2538 11.5549C23.6475 11.8491 23.8793 12.3118 23.8793 12.8033V23.8325C23.8793 24.324 23.6475 24.7867 23.2538 25.0809L16.3881 30.2117C15.8348 30.6252 15.0755 30.6252 14.5222 30.2117L7.65653 25.0809C7.26284 24.7867 7.031 24.324 7.031 23.8325V12.8033C7.031 12.3118 7.26284 11.8491 7.65653 11.5549L14.5222 6.42406Z",
    fill: "url(#paint0_linear_202_1424)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_202_1424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.065 32.7708C15.3061 32.6316 15.6031 32.6316 15.8442 32.7708L18.2929 34.1845C18.534 34.3237 18.6825 34.581 18.6825 34.8594V37.6869C18.6825 37.9653 18.534 38.2225 18.2929 38.3617L15.8442 39.7755C15.6031 39.9147 15.3061 39.9147 15.065 39.7755L12.6163 38.3617C12.3752 38.2225 12.2267 37.9653 12.2267 37.6869V34.8594C12.2267 34.581 12.3752 34.3237 12.6163 34.1845L15.065 32.7708Z",
    fill: "url(#paint1_linear_202_1424)"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.519486,
    y1: 17.8443,
    x2: 3.57146,
    y2: 17.8443,
    stroke: "url(#paint2_linear_202_1424)",
    strokeWidth: 1.03897,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 27.3374,
    y1: 17.8443,
    x2: 30.3893,
    y2: 17.8443,
    stroke: "url(#paint3_linear_202_1424)",
    strokeWidth: 1.03897,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 23.7258,
    y1: 6.43034,
    x2: 25.8839,
    y2: 4.27227,
    stroke: "url(#paint4_linear_202_1424)",
    strokeWidth: 1.03897,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 5.00688,
    y1: 4.27228,
    x2: 7.16495,
    y2: 6.43035,
    stroke: "url(#paint5_linear_202_1424)",
    strokeWidth: 1.03897,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 15.5197,
    y1: 0.519486,
    x2: 15.5197,
    y2: 3.57146,
    stroke: "url(#paint6_linear_202_1424)",
    strokeWidth: 1.03897,
    strokeLinecap: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_202_1424)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8471 32.7705C15.606 32.6313 15.3089 32.6313 15.0678 32.7705L12.6191 34.1843C12.378 34.3235 12.2295 34.5807 12.2295 34.8591V34.8914H18.6854V34.8591C18.6854 34.5807 18.5369 34.3235 18.2958 34.1843L15.8471 32.7705Z",
    fill: "url(#paint7_linear_202_1424)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_202_1424",
    x: 6.25178,
    y: 5.33475,
    width: 19.9653,
    height: 27.5248,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.779229,
    dy: 0.779229
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.779229
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_202_1424"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_202_1424",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_202_1424",
    x: 11.4473,
    y: 31.8872,
    width: 9.57297,
    height: 10.3304,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.779229,
    dy: 0.779229
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.779229
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_202_1424"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_202_1424",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_202_1424",
    x: 11.4503,
    y: 31.8869,
    width: 9.57272,
    height: 5.34223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.779229,
    dy: 0.779229
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.779229
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_202_1424"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_202_1424",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_202_1424",
    x1: 25.1825,
    y1: 5.72687,
    x2: 5.72778,
    y2: 5.72687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90278F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B491FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_202_1424",
    x1: 15.4546,
    y1: 32.5458,
    x2: 15.4546,
    y2: 40.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F36EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90278F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_202_1424",
    x1: 2.04547,
    y1: 18.3638,
    x2: 2.04547,
    y2: 19.3638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F36EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90278F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_202_1424",
    x1: 28.8633,
    y1: 18.3638,
    x2: 28.8633,
    y2: 19.3638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F36EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90278F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_202_1424",
    x1: 25.1722,
    y1: 5.71864,
    x2: 25.8793,
    y2: 6.42575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F36EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90278F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_202_1424",
    x1: 5.71859,
    y1: 5.71865,
    x2: 5.01148,
    y2: 6.42575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F36EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90278F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_202_1424",
    x1: 15.0002,
    y1: 2.04547,
    x2: 14.0002,
    y2: 2.04547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F36EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90278F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_202_1424",
    x1: 18.6854,
    y1: 32.6661,
    x2: 12.2295,
    y2: 32.6661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90278F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B491FF"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeas);
export default __webpack_public_path__ + "static/media/ideas.8cc95d67c9b3cf3e98f00cb1a7544f92.svg";
export { ForwardRef as ReactComponent };